import {
	onWatcherCleanup,
	shallowReadonly,
	shallowRef,
	toValue,
	watch,
	type MaybeRefOrGetter,
	type ShallowRef,
} from "vue";
import { useMap } from "./google-map";

export function useViewportMarkers(
	enabled: MaybeRefOrGetter<boolean>,
	markers: MaybeRefOrGetter<google.maps.Marker[]>
): Readonly<ShallowRef<google.maps.Marker[]>> {
	const map = useMap();

	const viewportMarkers = shallowRef<google.maps.Marker[]>([]);

	function updateViewportMarkers() {
		if (map.value == null) {
			return;
		}

		if (!toValue(enabled)) {
			viewportMarkers.value = toValue(markers);
			return;
		}

		const bounds = map.value.getBounds();
		if (bounds == null) {
			return;
		}

		viewportMarkers.value = [];

		for (const marker of toValue(markers)) {
			const pos = marker.getPosition();
			if (pos == null) {
				continue;
			}

			if (bounds.contains(pos)) {
				viewportMarkers.value.push(marker);
			}
		}
	}

	watch([map, () => toValue(markers), () => toValue(enabled)], updateViewportMarkers);
	watch(map, () => {
		if (map.value == null) {
			return;
		}

		const listener = map.value.addListener("idle", updateViewportMarkers);
		onWatcherCleanup(() => listener.remove());
	});

	return shallowReadonly(viewportMarkers);
}
